module.exports = __webpack_public_path__ + "img/celien-rombouts.22434925.png";